import { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../SubComponents/Header";
import { Formik, Form } from "formik";
import {
  Typography,
  Grid,
  Container,
  Box,
  InputAdornment,
  IconButton,
  useMediaQuery,
  Link,
  Button,
} from "@material-ui/core";
import Textfield from "../FormsUI/Textfield";
import Checkbox from "../FormsUI/Checkbox";
import ButtonSubmit from "../FormsUI/Button";
import { useTheme } from "@material-ui/core";
import view from "../../assets/images/view.svg";
import unview from "../../assets/images/unview.svg";
import AuthImage from "../SubComponents/AuthImage";
import useStyles from "../Styles/AuthStyles";
import newimageauth from "../../assets/images/authbanner.png";
import PasswordStrengthIndicator from "../../helpers/PasswordStrengthIndicator";
import { SignupFormValidation } from "../../helpers/Validations";
import { useContext } from "react";
import AuthState from "../../store/Auth/AuthContext";
import useGoogleStyles from "./useGoogleStyles";
import DoubleLineText from "../SubComponents/DoubleLineText";
import GoogleLogin from "./GoogleLogin";
import { FcGoogle } from "react-icons/fc";
import Recaptcha from "./Recaptcha";

const INITIAL_FORM_STATE = {
  username: "",
  email: "",
  password: "",
  repassword: "",
  termsOfService: false,
  captcha: null,
};

const SignUp: FC = () => {
  const classes = useStyles();
  const googleClasses = useGoogleStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const history = useHistory();
  const { isAuth, SignUpService } = useContext<any>(AuthState);

  if (isAuth) {
    history.push("/deals");
  }

  const [password, setPassword] = useState({
    showPassword: false,
    showPassword2: false,
  });

  const [captcha, setCaptcha] = useState<any>(null);

  const handleClickShowPassword = () => {
    setPassword({ ...password, showPassword: !password.showPassword });
  };
  const handleClickShowPassword2 = () => {
    setPassword({ ...password, showPassword2: !password.showPassword2 });
  };

  const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };
  const View = () => {
    return <img src={view} className="img-fluid" alt="Gains" />;
  };
  const Unview = () => {
    return <img src={unview} className="img-fluid" alt="Gains" />;
  };
  const Consent = () => {
    return (
      <Typography variant="subtitle1" color="secondary" className="fw-normal">
        By creating an account you agree to our
        <Link
          className="text-decoration-none"
          target="_blank"
          href="https://www.gains-associates.com/terms&conditions"
        >
          <Typography
            variant="subtitle1"
            component="span"
            color="secondary"
            className="fw-bold"
          >
            {" "}
            Terms of Services
          </Typography>
        </Link>{" "}
        and
        <Link
          className="text-decoration-none"
          target="_blank"
          href="https://www.gains-associates.com/privacy-policy"
        >
          <Typography
            variant="subtitle1"
            component="span"
            color="secondary"
            className="fw-bold"
          >
            {" "}
            Privacy Policy
          </Typography>
        </Link>
      </Typography>
    );
  };

  const isNumberRegx = /\d/;
  const lowerUpperCase = /[A-Z]/;
  const isSpecialCharacter = /[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]/;
  const [passwordFocused, setPasswordFocused] = useState(false);

  const [passwordValidity, setPasswordValidity] = useState({
    specialCharacter: false,
    minChar: false,
    number: false,
    lowerUpper: false,
    invalidText: false,
  });

  const onChangePassword = (password: { password: string }) => {
    setPasswordValidity({
      specialCharacter: isSpecialCharacter.test(password.password),
      minChar:
        password.password.length >= 8 && password.password.length <= 36
          ? true
          : false,
      number: isNumberRegx.test(password.password) ? true : false,
      lowerUpper: lowerUpperCase.test(password.password) ? true : false,
      invalidText: password.password.toLowerCase().includes("gains")
        ? false
        : true,
    });
  };

  return (
    <Box className={classes.authpages} component="section">
      <Header authPage />
      <>
        <Container fixed>
          <Grid container spacing={0}>
            <Grid className="borderleft" item md={5} sm={12}>
              <AuthImage image={newimageauth} />
            </Grid>
            <Grid className="borderleft" item md={7} sm={12}>
              <Box pl={isActive ? 0 : 7} pr={isActive ? 0 : 7}>
                <Typography
                  variant={isActive ? "h1" : "h2"}
                  color="primary"
                  className="mb-16"
                >
                  Create
                  <Typography
                    component="span"
                    variant={isActive ? "h1" : "h2"}
                    color="secondary"
                  >
                    {" "}
                    Account
                  </Typography>
                </Typography>
                <Formik
                  initialValues={{
                    ...INITIAL_FORM_STATE,
                  }}
                  validationSchema={SignupFormValidation}
                  validate={onChangePassword}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    if (
                      !passwordValidity.specialCharacter ||
                      !passwordValidity.minChar ||
                      !passwordValidity.number ||
                      !passwordValidity.lowerUpper ||
                      !passwordValidity.invalidText
                    ) {
                      return;
                    }

                    values = {
                      ...values,
                      username: values.username.toLowerCase(),
                      email: values.email.toLowerCase(),
                      captcha: captcha,
                    };
                    SignUpService(values);
                  }}
                >
                  {({ values, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={isActive ? 2 : 3}>
                        <Grid item md={12} xs={12}>
                          <Typography
                            variant="subtitle1"
                            color="secondary"
                            className="fw-normal"
                          >
                            Username
                          </Typography>
                          <Textfield
                            name="username"
                            placeholder="Enter Username"
                            id="username"
                            area-aria-invalid="username"
                            margin="dense"
                            value={values.username.toLowerCase()}
                          />
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <Typography
                            variant="subtitle1"
                            color="secondary"
                            className="fw-normal"
                          >
                            Email
                          </Typography>
                          <Textfield
                            name="email"
                            id="email"
                            placeholder="Email"
                            margin="dense"
                            value={values.email.toLowerCase()}
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography
                            variant="subtitle1"
                            color="secondary"
                            className="fw-normal"
                          >
                            Password
                          </Typography>
                          <Textfield
                            name="password"
                            onFocus={() => setPasswordFocused(true)}
                            value={values.password}
                            type={password.showPassword ? "text" : "password"}
                            placeholder="Enter Password"
                            margin="dense"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    color="secondary"
                                  >
                                    {password.showPassword ? (
                                      <Unview />
                                    ) : (
                                      <View />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography
                            variant="subtitle1"
                            color="secondary"
                            className="fw-normal"
                          >
                            Re-enter Password
                          </Typography>
                          <Textfield
                            name="repassword"
                            type={password.showPassword2 ? "text" : "password"}
                            placeholder="Re - Enter Password"
                            margin="dense"
                            autoComplete="false"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword2}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    color="secondary"
                                  >
                                    {password.showPassword2 ? (
                                      <Unview />
                                    ) : (
                                      <View />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        {passwordFocused && (
                          <Grid item md={12} xs={12}>
                            <PasswordStrengthIndicator
                              validity={passwordValidity}
                            />
                          </Grid>
                        )}
                        <Grid className="pt-0" item md={12} xs={12}>
                          <Checkbox
                            error="Required"
                            name="termsOfService"
                            label={<Consent />}
                            color="secondary"
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        className="align-self-center pt-10"
                        item
                        md={6}
                        xs={6}
                      >
                        <Recaptcha setCaptcha={setCaptcha} />
                      </Grid>
                      <Grid
                        container
                        lg={6}
                        xs={12}
                        direction="column"
                        spacing={2}
                      >
                        <Grid item className="mt-12">
                          <ButtonSubmit
                            disabled={
                              isSubmitting ||
                              !passwordValidity.specialCharacter ||
                              !passwordValidity.minChar ||
                              !passwordValidity.number ||
                              !passwordValidity.lowerUpper ||
                              !passwordValidity.invalidText ||
                              !captcha
                            }
                            fullWidth
                          >
                            Sign Up
                          </ButtonSubmit>
                        </Grid>
                        <Grid item>
                          <DoubleLineText text={"OR"} />
                        </Grid>
                        <Grid item>
                          <div
                            className={googleClasses.googleLoginContainer}
                            style={{ width: "100%" }}
                          >
                            <GoogleLogin />
                            <div>
                              <Button
                                variant="contained"
                                startIcon={<FcGoogle />}
                                fullWidth
                                className={googleClasses.customGoogle}
                                style={{
                                  top: isActive ? 7 : 0,
                                }}
                              >
                                Continue With Google
                              </Button>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </>
    </Box>
  );
};

export default SignUp;
